import React, { useContext } from 'react';
import { Modal } from '@amzn/awsui-components-react/polaris';
import { SegmentTablesContext } from 'src/components/segment-cdt/SegmentTablesContext';
import { ACTIONS } from 'src/services/segment-cdt/SegmentTablesReducer';
import SegmentMetaStep from 'src/components/segment-cdt/create/SegmentMetaStep';
import SegmentColumnsStep from 'src/components/segment-cdt/create/SegmentColumnsStep';

/**
 * Create Segment Data Table wizard. A single modal hosting Step 1 (meta) → Step 2 (columns). The steps
 * read everything from `SegmentTablesContext` and dispatch cancel/submit themselves, so this is a thin
 * shell: it owns only the modal chrome and the dismiss guard. Opened via `OPEN_CREATE_WIZARD`.
 */
export default function SegmentCreateWizard() {
    const { state, dispatch } = useContext(SegmentTablesContext);
    const cw = state.createWizard;

    return (
        <Modal
            visible={cw.visible}
            // Don't let Esc / overlay / close-icon dismiss the wizard mid-create: closing resets the slice
            // (including `creating`) while the request is still in flight.
            onDismiss={() => { if (!cw.creating) dispatch(ACTIONS.CLOSE_CREATE_WIZARD); }}
            size="large"
            closeAriaLabel="Close modal"
            header={cw.currentStep === 1 ? 'Create Segment Data Table' : `Add columns: ${cw.tableName}`}
        >
            {cw.currentStep === 1 ? <SegmentMetaStep /> : <SegmentColumnsStep />}
        </Modal>
    );
}
